var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    key: _vm.forceReRender,
    staticClass: "issue"
  }, _vm._l(_vm.groupedProtocolObj, function (rowData, rowIndex) {
    return _c('ul', {
      key: rowIndex,
      staticClass: "protocolList"
    }, [_c('ul', {
      staticClass: "protocolItem group"
    }, [_c('ul', {
      staticClass: "type",
      attrs: {
        "data-grid": "type"
      },
      on: {
        "mousedown": function ($event) {
          $event.stopPropagation();
          return _vm.startDrag.apply(null, arguments);
        },
        "mousemove": function ($event) {
          $event.stopPropagation();
          return _vm.onDrag.apply(null, arguments);
        },
        "mouseup": function ($event) {
          $event.stopPropagation();
          return _vm.endDrag.apply(null, arguments);
        },
        "mouseleave": function ($event) {
          $event.stopPropagation();
          return _vm.endDrag.apply(null, arguments);
        }
      }
    }, _vm._l(rowData[0], function (category, categoryIndex) {
      return _c('li', {
        key: categoryIndex,
        attrs: {
          "data-type": category.type.toLowerCase(),
          "data-items": category.items[0]
        }
      }, [_vm._v(" " + _vm._s(_vm.ellipsisText(category.items[0])) + " ")]);
    }), 0), _c('li', {
      staticClass: "protocolItem",
      class: {
        'active': rowData[2].protocolId == _vm.selectedProtocolId || rowData[1].includes(_vm.keyOfProtocol)
      }
    }, [_c('div', {
      staticClass: "info",
      attrs: {
        "data-grid": "info"
      }
    }, [_c('p', {
      staticClass: "title",
      attrs: {
        "data-grid": "title"
      },
      domProps: {
        "innerHTML": _vm._s(rowData[2].name)
      }
    }), _c('p', {
      staticClass: "titleEng",
      attrs: {
        "data-grid": "titleEng"
      },
      domProps: {
        "innerHTML": _vm._s(rowData[2].nameEng)
      }
    }), _c('p', {
      staticClass: "user"
    }, [_c('span', [_vm._v(_vm._s(rowData[2].user.userName))]), _c('span', [_vm._v(_vm._s(rowData[2].user.companyName))])])]), _c('div', {
      staticClass: "link",
      attrs: {
        "data-grid": "link"
      }
    }, [_c('button', {
      on: {
        "click": function ($event) {
          return _vm.callProtocolDetail(rowData[2].protocolId, 'tree');
        }
      }
    }, [_vm._v("트리")]), _c('button', {
      on: {
        "click": function ($event) {
          return _vm.callProtocolDetail(rowData[2].protocolId, 'wiki');
        }
      }
    }, [_vm._v("위키")])])])])]);
  }), 0);

}
var staticRenderFns = []

export { render, staticRenderFns }